<!--
 * @Description: 返回报名成功页
 * @Author: 山淑兰
 * @Date: 2019-12-16 10:41:17
 * @LastEditTime: 2020-07-15 16:22:01
 * @LastEditors: 山淑兰
 -->
<template>
    <div class="foot-nav" v-if="fNavigation.length>0">
        <ul class="fnav">
            <li v-for="(item,index) in fNavigation" :key='index'>
                <a :href="item.navurl" v-if="item.navurl != null">
                    <img :src="item.icon_path">
                    {{ item.title }}
                </a>
                <!-- <a @click="personCenter" v-if="item.navurl == null">
                    <img :src="item.icon_path">
                    {{ item.title }}
                </a> -->
                <a @click="personCenter" v-else-if="item.navurl == null&&item.menucontent=='PERSONALCENTER'" :class="activeShow?'active':''">
                    <img :src="item.icon_path">
                    {{ item.title }}
                </a>
                <a @click="my" v-else-if="item.navurl == null&&item.menucontent=='UserCenter'" :class="activeShow1?'active':''">
                    <img :src="item.icon_path">
                    {{ item.title }}
                </a>
                <a @click="checkInfo" v-else-if="item.navurl == null&&item.menucontent=='CheckInfo'" :class="activeShow2?'active':''">
                    <img :src="item.icon_path">
                    {{ item.title }}
                </a>
                <a v-else>
                    <img :src="item.icon_path">
                    {{ item.title }}
                </a>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'navigation',
      data() {
      return {
        fNavigation: '',
        activeShow: false,
        activeShow1: false,
        activeShow2: false
      }
    },
	props: {
		height: {
		  type: Boolean,
		  default: true
		},
	},
    created() {
        this.footNav()
        this.navActive()
    },
    methods: {
        async footNav() {
            try {
                let params = {
                    m: this.$route.query.m
                }
                let res = await this.$http.expertNav(params)

                this.fNavigation = res.Items
				if( this.fNavigation && this.fNavigation.length > 0 ){
					this.height = true
				}else{
					this.height = false
				}
            } catch (err) {
                console.log(err)
            }
        },
        navActive(){
            if (this.$route.path == '/signup/signupinfo') {
                this.activeShow = true
            }else{
                this.activeShow = false
            }
            if (this.$route.path == '/signup/my') {
                this.activeShow1 = true
            }else{
                this.activeShow1 = false
            }
        },
        personCenter() {
            if (this.$route.path == '/signup/modifyInfo') {
                delete this.$route.query.muid
            }
            this.$router.push({
                path: '/signup/signupinfo',
                query: this.$route.query,
            })
            this.activeShow = true
            this.activeShow1 = false
            this.activeShow2 = false
        },
        my(){
            this.$router.push({
                path: '/signup/my',
                query: this.$route.query,
            })
            this.activeShow = false
            this.activeShow1 = true
            this.activeShow2 = false
        },
        checkInfo(){
            this.$router.push({
                path: '/signup/electronicticket',
                query: this.$route.query,
            })
            this.activeShow = false
            this.activeShow1 = false
            this.activeShow2 = true
        },
    },
}
</script>
<style scoped lang="scss">
.foot-nav {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    width: 100%;
    height: 75px;
    padding: 5px 0;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(8px);
    box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.06);
    border-top: 1px solid #e2e8f0;

    .fnav {
        width: 100%;
        height: 75px;
        display: flex;
        font-size: 22px;

        li {
            flex: 1;
            text-align: center;
            color: #64748b;
            border-right: 1px solid #f1f5f9;

            a {
                color: #64748b;
                display: block;
                width: 100%;
                height: 100%;
                transition: color 0.2s;
            }
            a.active{
                color: #3b82f6;
                font-weight: 600;
            }
            img {
                display: block;
                width: 40px;
                height: 40px;
                margin: 0 auto;
            }
        }

        li:last-child {
            border-right: none;
        }
    }
}
</style>